import { ContentHubTeaserCard } from '../../molecules/ContentHubTeaserCard';

import ContentHubTeaserDynamicWrapper from './partials/ContentHubTeaserDynamicWrapper';
import {
  ContentHubStyle1,
  ContentHubStyle2,
  ContentHubStyle5,
  ContentHubStyle5Main,
  ContentHubStyle5Rows,
} from './ContentHubTeaser.styles';
import ContentHubTeaserCardWrapper from './partials/ContentHubTeaserCardWrapper';

/**
 * @param {ContentHubTeaserProps} props
 * @returns {React.ReactElement} The rendered component
 */
export default function ContentHubTeaser({
  style,
  items,
  language,
  isContentHubCategoryPage,
}) {
  switch (style) {
    case 'TEASER_1':
      return (
        <ContentHubStyle1>
          {items.slice(0, 1).map((teaser) => (
            <ContentHubTeaserCard
              key={teaser.id}
              format={'landscape'}
              {...teaser}
              isContentHubCategoryPage={isContentHubCategoryPage}
            />
          ))}
        </ContentHubStyle1>
      );
    case 'TEASER_2':
      return (
        <ContentHubStyle2>
          {items.slice(0, 2).map((teaser) => (
            <ContentHubTeaserCard
              key={teaser.id}
              format={'square'}
              {...teaser}
              isContentHubCategoryPage={isContentHubCategoryPage}
            />
          ))}
        </ContentHubStyle2>
      );
    case 'TEASER_3':
      return (
        <ContentHubTeaserCardWrapper
          teasers={items}
          isContentHubCategoryPage={isContentHubCategoryPage}
        />
      );
    case 'TEASER_3_CONTENT':
      return (
        <ContentHubTeaserDynamicWrapper
          teasers={items.slice(0, 3)}
          language={language}
        />
      );
    case 'TEASER_5':
      return (
        <ContentHubStyle5>
          <ContentHubStyle5Rows>
            {items.slice(1, 3).map((teaser) => (
              <ContentHubTeaserCard
                key={teaser.id}
                format={'square'}
                {...teaser}
                isContentHubCategoryPage={isContentHubCategoryPage}
              />
            ))}
          </ContentHubStyle5Rows>
          <ContentHubStyle5Main>
            {items.slice(0, 1).map((teaser) => (
              <ContentHubTeaserCard
                key={teaser.id}
                format={'square'}
                {...teaser}
                isContentHubCategoryPage={isContentHubCategoryPage}
              />
            ))}
          </ContentHubStyle5Main>
          <ContentHubStyle5Rows>
            {items.slice(3, 5).map((teaser) => (
              <ContentHubTeaserCard
                key={teaser.id}
                format={'square'}
                {...teaser}
                isContentHubCategoryPage={isContentHubCategoryPage}
              />
            ))}
          </ContentHubStyle5Rows>
        </ContentHubStyle5>
      );
    default:
      return <></>;
  }
}
